module.exports = __webpack_public_path__ + "static/media/ic-slideshow-arrow.709f84b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-slideshow-arrow.svg
// module id = 668
// module chunks = 14